import { render, staticRenderFns } from "./photoViewer.vue?vue&type=template&id=613b6d4e&scoped=true&"
import script from "./photoViewer.vue?vue&type=script&lang=js&"
export * from "./photoViewer.vue?vue&type=script&lang=js&"
import style0 from "./photoViewer.vue?vue&type=style&index=0&id=613b6d4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b6d4e",
  null
  
)

export default component.exports